import React, { useState, useEffect } from "react";

import {
    Card,
    CardBody,
    Col,
    Container,
    Form,
    Input,
    NavItem,
    NavLink,
    Row,
    TabContent,
    TabPane,
    Label,
    FormFeedback,
    UncontrolledAlert,
    Spinner,
    FormGroup,
    Button,
    CardTitle,
    CardSubtitle,
} from "reactstrap";
import { get, put, del } from "../../Services/RestAPIService";
import { useFormik } from "formik";
import * as Yup from "yup";
import classnames from "classnames";
import { Link } from "react-router-dom";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { useParams, useNavigate } from "react-router-dom";
import AlertModal from "components/AlertModal";
import SelectCategories from "./EditFormComponents/SelectCategories";
import SelectTime from "./EditFormComponents/SelectTime";
import BulkSelectTime from "./EditFormComponents/EditBulkTime";
import DummyImage from "../../assets/images/No_Image_Available.jpg"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

const FormWizard = () => {
    const navigate = useNavigate();
    const [activeTab, setactiveTab] = useState(1);
    const [activeTabProgress, setactiveTabProgress] = useState(1);
    const [progressValue, setprogressValue] = useState(25);
    const [activeTabVartical, setoggleTabVertical] = useState(1);
    const [profileImage, setProfileImage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [id, setId] = useState(null);
    const [userData, setUserData] = useState(null);
    const [alert, setAlert] = useState({ color: "", message: "", visible: false });
    const [isLoadingDel, setIsLoadingDel] = useState(false);
    const [isAlertModal, setIsAlertModal] = useState(false);
    const { userId } = useParams();

    useEffect(() => {
        getUserData();
    }, []);

    const getUserData = async () => {
        try {
            const data = await get(`v1/users/${userId}/`);
            setUserData(data);
        } catch (error) {
            console.error("Error fetching user data:", error);
        }
    };





    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            firstname: userData?.first_name || "",
            lastname: userData?.last_name || "",
            email: userData?.email || "",
            status: userData?.status?.toString() || "",
            mobile: userData?.mobile_number || "",
            gender: userData?.gender || "",
        },
        validationSchema: Yup.object({
            firstname: Yup.string().required("Please Enter Your First Name"),
            lastname: Yup.string().required("Please Enter Your Last Name"),
            email: Yup.string().email("Invalid email address").required("Email is required"),
            status: Yup.string().required("Please select the status"),
            mobile: Yup.string().required("Please enter your mobile number"),
            gender: Yup.string().required("Please select your gender"),
        }),
        onSubmit: async (values) => {
            setIsLoading(true);
            const data = {
                first_name: values.firstname,
                last_name: values.lastname,
                email: values.email,
                status: values.status,
                mobile_number: values.mobile,
                gender: values.gender,
                ...(profileImage && { profile_image: profileImage }),
            };

            try {
                const response = await put(`v1/users/${userId}/`, data, {
                    headers: { "Content-Type": "application/json" },
                    validateStatus: false,
                });
                if (response.status === 200) {
                    setAlert({
                        color: "success",
                        visible: true,
                        message: "Data updated successfully!",
                    });
                    setTimeout(() => {
                        setAlert({ visible: false });
                    }, 3000);
                } else {
                    const errorMessage =
                        response.data?.error || "An error occurred while updating data.";
                    setAlert({
                        color: "danger",
                        visible: true,
                        message: errorMessage,
                    });
                    setTimeout(() => {
                        setAlert({ visible: false });
                    }, 3000);
                }
            } catch (error) {
                console.error("Error updating user data:", error);
                setAlert({
                    color: "danger",
                    visible: true,
                    message: "Error Updating User Data",
                });
                setTimeout(() => {
                    setAlert({ visible: false });
                }, 3000);
            } finally {
                setIsLoading(false);
            }
        },
    });

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result;
                setProfileImage(base64String);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleDelete = async () => {
        setIsLoadingDel(true);
        setIsAlertModal(false);

        try {
            const response = await del(`v1/users/${userId}/`);
            if (response.status <= 400) {
                setAlert({
                    color: "success",
                    visible: true,
                    message: "User deleted successfully!",
                });
                setTimeout(() => {
                    setAlert({ visible: false });
                    navigate(`/users/`);
                }, 3000);
            } else {
                const errorMessage =
                    response.data?.error || "An error occurred while deleting user.";
                setAlert({
                    color: "danger",
                    visible: true,
                    message: errorMessage,
                });
                setTimeout(() => {
                    setAlert({ visible: false });
                }, 3000);
            }
        } catch (error) {
            console.error("Error deleting user:", error);
            setAlert({
                color: "danger",
                visible: true,
                message: "Error Deleting User",
            });
            setTimeout(() => {
                setAlert({ visible: false });
            }, 3000);
        } finally {
            setIsLoadingDel(false);
            setTimeout(() => {
                setAlert({ visible: false });
                navigate(`/users/`);
            }, 1500);
        }
    };


    const handleAlerts = (value) => {
        setAlert({
            color: value.color,
            visible: value.visible,
            message: value.message,
            strongM: value.strongM
        });
        setTimeout(() => {
            setAlert({ visible: false });
        }, 3000);
    }



    function toggleTab(tab) {
        if (activeTab !== tab) {
            if (tab >= 1 && tab <= 4) {
                setactiveTab(tab);
            }
        }
    }

    function toggleTabVertical(tab) {
        if (activeTabVartical !== tab) {
            if (tab >= 1 && tab <= 4) {
                setoggleTabVertical(tab);
            }
        }
    }

    function toggleTabProgress(tab) {
        if (activeTabProgress !== tab) {
            if (tab >= 1 && tab <= 4) {
                setactiveTabProgress(tab);

                if (tab === 1) {
                    setprogressValue(25);
                }
                if (tab === 2) {
                    setprogressValue(50);
                }
                if (tab === 3) {
                    setprogressValue(75);
                }
                if (tab === 4) {
                    setprogressValue(100);
                }
            }
        }
    }
    document.title = "Form Wizard | Llosana";


    return (
        <React.Fragment>

            {alert.visible && <UncontrolledAlert className="Alert_Additions_Log" color={`${alert.color || "warning"}`} role="alert">
                {alert?.message || "Welcome"}
            </UncontrolledAlert>}

            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumbs maintitle="Home" title="Consultant" breadcrumbItem="Consultant Profile" />

                    <Row>
                        <Col sm="12">
                            <Card>
                                <CardBody>
                                    <h4 className="card-title mb-4">Edit Details</h4>
                                    <p>Click on Tab to Switch</p>
                                    <div className="form-horizontal form-wizard-wrapper wizard clearfix">
                                        <div className="steps clearfix">
                                            <ul>
                                                <NavItem
                                                    className={classnames({ current: activeTab === 1 })}>
                                                    <NavLink
                                                        className={classnames({ current: activeTab === 1 })}
                                                        onClick={() => {
                                                            setactiveTab(1);
                                                        }}
                                                    >
                                                        {/* <span className="number">1.</span>{" "} */}
                                                     Details
                                                    </NavLink>
                                                </NavItem>
                                                <NavItem className={classnames({ current: activeTab === 2 })}>
                                                    <NavLink
                                                        className={classnames({ active: activeTab === 2 })}
                                                        onClick={() => {
                                                            setactiveTab(2);
                                                        }}
                                                    >
                                                        {/* <span className="number">2.</span>{" "} */}
                                                        Modify Categories
                                                    </NavLink>
                                                </NavItem>
                                                <NavItem className={classnames({ current: activeTab === 3 })}>
                                                    <NavLink
                                                        className={classnames({ active: activeTab === 3 })}
                                                        onClick={() => {
                                                            setactiveTab(3);
                                                        }}
                                                    >
                                                        {/* <span className="number">3.</span> */}
                                                        Time Availability
                                                    </NavLink>
                                                </NavItem>
                                                <NavItem className={classnames({ current: activeTab === 4 })}>
                                                    <NavLink
                                                        className={classnames({ active: activeTab === 4 })}
                                                        onClick={() => {
                                                            setactiveTab(4);
                                                        }}
                                                    >
                                                        {/* <span className="number">3.</span> */}
                                                        Bulk Time Availability
                                                    </NavLink>
                                                </NavItem>
                                            </ul>
                                        </div>
                                        <div className="content clearfix">
                                            <TabContent
                                                activeTab={activeTab}
                                                className="body"
                                            >
                                                <TabPane tabId={1}>
                                                    {/* <Form> */}

                                                    <Row>
                                                        <Col lg={4}>
                                                            <Card>
                                                                <CardBody>
                                                                    <div className="text-center">
                                                                        <img
                                                                            src={profileImage || userData?.profile_image || DummyImage}
                                                                            alt="Profile"
                                                                            className="rounded-circle img-thumbnail avatar-xl"
                                                                        />
                                                                    </div>
                                                                    <div className="text-center mt-3">
                                                                        <input
                                                                            type="file"
                                                                            id="file"
                                                                            style={{ display: "none" }}
                                                                            accept="image/*"
                                                                            onChange={handleImageChange}
                                                                        />
                                                                        <label htmlFor="file" className="btn btn-primary">
                                                                            Change Picture
                                                                        </label>
                                                                    </div>
                                                                </CardBody>
                                                            </Card>
                                                        </Col>
                                                        <Col lg={8}>
                                                            <Card>
                                                                <CardBody>
                                                                    <CardTitle>Edit User</CardTitle>
                                                                    <CardSubtitle className="mb-3">
                                                                        You can Edit User Profile from here.
                                                                    </CardSubtitle>
                                                                    <Form onSubmit={validation.handleSubmit}>
                                                                        <div className="mb-3">
                                                                            <Label className="form-label">First Name</Label>
                                                                            <Input
                                                                                name="firstname"
                                                                                type="text"
                                                                                onChange={validation.handleChange}
                                                                                onBlur={validation.handleBlur}
                                                                                value={validation.values.firstname || ""}
                                                                                invalid={
                                                                                    validation.touched.firstname &&
                                                                                    validation.errors.firstname
                                                                                }
                                                                            />
                                                                            {validation.touched.firstname &&
                                                                                validation.errors.firstname && (
                                                                                    <FormFeedback type="invalid">
                                                                                        {validation.errors.firstname}
                                                                                    </FormFeedback>
                                                                                )}
                                                                        </div>
                                                                        <div className="mb-3">
                                                                            <Label className="form-label">Last Name</Label>
                                                                            <Input
                                                                                name="lastname"
                                                                                type="text"
                                                                                onChange={validation.handleChange}
                                                                                onBlur={validation.handleBlur}
                                                                                value={validation.values.lastname || ""}
                                                                                invalid={
                                                                                    validation.touched.lastname &&
                                                                                    validation.errors.lastname
                                                                                }
                                                                            />
                                                                            {validation.touched.lastname &&
                                                                                validation.errors.lastname && (
                                                                                    <FormFeedback type="invalid">
                                                                                        {validation.errors.lastname}
                                                                                    </FormFeedback>
                                                                                )}
                                                                        </div>
                                                                        <div className="mb-3">
                                                                            <Label className="form-label">Email</Label>
                                                                            <Input
                                                                                name="email"
                                                                                type="email"
                                                                                onChange={validation.handleChange}
                                                                                onBlur={validation.handleBlur}
                                                                                value={validation.values.email || ""}
                                                                                invalid={
                                                                                    validation.touched.email && validation.errors.email
                                                                                }
                                                                            />
                                                                            {validation.touched.email &&
                                                                                validation.errors.email && (
                                                                                    <FormFeedback type="invalid">
                                                                                        {validation.errors.email}
                                                                                    </FormFeedback>
                                                                                )}
                                                                        </div>
                                                                        <div className="mb-3">
                                                                            <Label className="form-label">Status</Label>
                                                                            <Input
                                                                                type="select"
                                                                                name="status"
                                                                                onChange={validation.handleChange}
                                                                                onBlur={validation.handleBlur}
                                                                                value={validation.values.status || ""}
                                                                                invalid={
                                                                                    validation.touched.status && validation.errors.status
                                                                                }
                                                                            >
                                                                                <option value="">Select Status</option>
                                                                                <option value="true">Active</option>
                                                                                <option value="false">Inactive</option>
                                                                            </Input>
                                                                            {validation.touched.status &&
                                                                                validation.errors.status && (
                                                                                    <FormFeedback type="invalid">
                                                                                        {validation.errors.status}
                                                                                    </FormFeedback>
                                                                                )}
                                                                        </div>
                                                                        <div className="mb-3">
                                                                            <Label className="form-label">Mobile Number</Label>
                                                                            <Input
                                                                                name="mobile"
                                                                                type="text"
                                                                                onChange={validation.handleChange}
                                                                                onBlur={validation.handleBlur}
                                                                                value={validation.values.mobile || ""}
                                                                                invalid={
                                                                                    validation.touched.mobile && validation.errors.mobile
                                                                                }
                                                                            />
                                                                            {validation.touched.mobile &&
                                                                                validation.errors.mobile && (
                                                                                    <FormFeedback type="invalid">
                                                                                        {validation.errors.mobile}
                                                                                    </FormFeedback>
                                                                                )}
                                                                        </div>
                                                                        <div className="mb-3">
                                                                            <Label className="form-label">Gender</Label>
                                                                            <Input
                                                                                type="select"
                                                                                name="gender"
                                                                                onChange={validation.handleChange}
                                                                                onBlur={validation.handleBlur}
                                                                                value={validation.values.gender || ""}
                                                                                invalid={
                                                                                    validation.touched.gender && validation.errors.gender
                                                                                }
                                                                            >
                                                                                <option value="">Select Gender</option>
                                                                                <option value="Male">Male</option>
                                                                                <option value="Female">Female</option>
                                                                                <option value="Other">Other</option>
                                                                            </Input>
                                                                            {validation.touched.gender &&
                                                                                validation.errors.gender && (
                                                                                    <FormFeedback type="invalid">
                                                                                        {validation.errors.gender}
                                                                                    </FormFeedback>
                                                                                )}
                                                                        </div>
                                                                        <div className="d-flex flex-wrap gap-2">
                                                                            <Button
                                                                                type="submit"
                                                                                color="primary"
                                                                                disabled={isLoading || isLoadingDel}
                                                                            >
                                                                                {isLoading ? (
                                                                                    <Spinner size="sm" color="light" />
                                                                                ) : (
                                                                                    "Submit"
                                                                                )}
                                                                            </Button>{" "}
                                                                            <Button
                                                                                onClick={() => {
                                                                                    setIsAlertModal(true);
                                                                                }}
                                                                                color="danger"
                                                                                disabled={isLoading || isLoadingDel}
                                                                            >
                                                                                {isLoadingDel ? (
                                                                                    <Spinner size="sm" color="light" />
                                                                                ) : (
                                                                                    "Delete"
                                                                                )}
                                                                            </Button>{" "}
                                                                            {isAlertModal && (
                                                                                <AlertModal
                                                                                    selection={(e) => {
                                                                                        e === true ? handleDelete() : setIsAlertModal(false);
                                                                                    }}
                                                                                    Display={null}
                                                                                />
                                                                            )}
                                                                        </div>
                                                                    </Form>
                                                                </CardBody>
                                                            </Card>
                                                        </Col>
                                                    </Row>


                                                    {/* </Form> */}
                                                </TabPane>
                                                <TabPane tabId={2}>

                                                    {/* Categories.js */}

                                                    <SelectCategories OnSubmit={null} Response={(value) => { toggleTab(value) }} Data={userId} Alerts={(value) => { handleAlerts(value) }} Loading={(value) => { setIsLoading(value) }} />

                                                </TabPane>
                                                <TabPane tabId={3}>


                                                    {/* Time Data */}

                                                    <SelectTime OnSubmit={null} Response={(value) => { toggleTab(value) }} Data={userId} Alerts={(value) => { handleAlerts(value) }} Loading={(value) => { setIsLoading(value) }} />

                                                </TabPane>
                                                <TabPane tabId={4}>
                                                    {/* <div className="row justify-content-center">
                                                        <Col lg="6">
                                                            <div className="text-center">
                                                                <div className="mb-4">
                                                                    <i className="mdi mdi-check-circle-outline text-success display-4" />
                                                                </div>
                                                                <div>
                                                                    <h5>Confirm Detail</h5>
                                                                    <p className="text-muted">
                                                                        Thank you Consultant is Registered.
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    </div> */}

                                                    <BulkSelectTime OnSubmit={null} Response={(value) => { toggleTab(value) }} Data={userId} Alerts={(value) => { handleAlerts(value) }} Loading={(value) => { setIsLoading(value) }} />
                                                </TabPane>
                                            </TabContent>
                                        </div>
                                        {/* <div className="actions clearfix">
                                            <ul>
                                                <li
                                                    className={
                                                        activeTab === 1 ? "previous disabled" : "previous"
                                                    }
                                                >
                                                    <Link
                                                        to="#"
                                                        onClick={() => {
                                                            toggleTab(activeTab - 1);
                                                        }}
                                                    >
                                                        Previous
                                                    </Link>
                                                </li>
                                                <li
                                                    className={activeTab === 4 ? "next disabled" : "next"}
                                                >
                                                    {activeTab === 3 && <Link
                                                        to="#"
                                                        onClick={() => {
                                                            toggleTab(activeTab + 1);
                                                        }}
                                                    >
                                                        Next
                                                    </Link>}

                                                    {activeTab === 1 && <Button form="DocRegister" type="submit" color="primary" disabled={isLoading}>
                                                        {isLoading ? (
                                                            <Spinner size="sm" color="light" />
                                                        ) : (
                                                            "Register Doctor"
                                                        )}
                                                    </Button>}



                                                    {activeTab === 2 && <Button form="CategoriesSelect" type="submit" color="primary" disabled={isLoading}>
                                                        {isLoading ? (
                                                            <Spinner size="sm" color="light" />
                                                        ) : (
                                                            "Submit Exercises"
                                                        )}
                                                    </Button>}


                                                </li>
                                            </ul>
                                        </div> */}
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default FormWizard;